export default {
  recommendationsTitle: {
    id: 'product_add_to_cart_page_accessories_title',
    defaultMessage: 'Goes well with',
  },
  crossSellTitle: {
    id: 'product_add_to_cart_page_cross_sell_title',
    defaultMessage: 'Others also bought',
  },
  back: {
    id: 'product_add_to_cart_page_back',
    defaultMessage: 'Back',
  },
  continue: {
    id: 'product_add_to_cart_page_go_to_cart',
    defaultMessage: 'Go to cart',
  },
}
